/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NumberFormat from 'react-number-format';
import Autocomplete from 'react-autocomplete';
import PulpoField from '../../../pulpo_visualizer/fields';
import fieldstyles from '../../../pulpo_visualizer/fields/fields.module.scss';
import FormattedMessageWithClass from '../../../components/formattedMessageWithClass';
import styles from './fixedFields.module.scss';
import Attachments from '../../forms/components/Attachments';

class FixedFields extends Component {
  state = { currentValue: undefined };

  static getDerivedStateFromProps(props, state) {
    if (props.info.logged_by?.id && state.currentValue === undefined) {
      return { ...state, currentValue: props.info.logged_by.fullname };
    }
    return state;
  }

  handleAutocompleteChange = (e) => {
    const { searchForUser } = this.props;
    this.setState({ currentValue: e.target.value });
    searchForUser(e.target.value);
  };

  handleAutocompleteSelect = (val, item) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;
    this.setState({ currentValue: val });
    handleAnswerChanged('info', item, 'logged_by');
    handleFieldErrorChanged('logged_by', false);
  };

  render() {
    const { currentValue } = this.state;
    const {
      handleAnswerChanged,
      showFormErrors,
      handleFieldErrorChanged,
      userlist,
      info,
      allCategories,
      prefix,
      getTotalRent,
      gross_contracts
    } = this.props;
    const filterCategories = info && info?.contract && allCategories?.length > 0
    && allCategories?.filter(obj => info?.contract.toString() === obj?.contract?.id?.toString()) || [];
    const matchingContract = gross_contracts?.find(contract => contract.id.toString() === info?.contract.toString());
    const min_val = matchingContract ? matchingContract.min_annual_gurantee : '0.00';
    return (
      <>
        <div className={`${fieldstyles.field}`}>
          <>
            <FormattedMessageWithClass
              className={fieldstyles.title}
              id="workorder.logged.by"
              defaultMessage="Logged by"
            />
            <Autocomplete
              getItemValue={item => item.fullname}
              items={userlist}
              wrapperStyle={{ position: 'relative' }}
              value={currentValue}
              onChange={this.handleAutocompleteChange}
              onSelect={this.handleAutocompleteSelect}
              renderMenu={children => (
                <div className={styles.autocompleteMenu}>{children}</div>
              )}
              renderItem={(item, isHighlighted) => (
                <div key={item.id} className={`${styles.menuItem} ${isHighlighted && styles.highlighted}`}>
                  {item.fullname}
                </div>
              )}
            />
            {!currentValue && showFormErrors && (
              <small>
                <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="There is an error in this field" />
              </small>
            )}
          </>
        </div>
        <PulpoField
          key="date"
          id="report_date"
          type="datetime"
          translationID="workorder.create.datea"
          title="Date and Time"
          isRequired
          handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
          answer={info.report_date}
          className={styles.logged}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
        />
        <PulpoField
          key="month"
          id="month"
          type="select"
          translationID="workorder.create.datea"
          title="Month"
          className={styles.month}
          isRequired
          handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
          values={Array.from({ length: 12 }, (_, i) => ({
            value: `${i + 1}`,
            key: `${i + 1}`
          }))}
          answer={info.month}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
        />
        <PulpoField
          key="quarter"
          id="quarter"
          type="select"
          avp
          translationID="workorder.create.datea"
          title="Quarter"
          className={styles.month}
          isRequired
          handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
          values={[
            { value: 'Q1', key: '1' },
            { value: 'Q2', key: '2' },
            { value: 'Q3', key: '3' },
            { value: 'Q4', key: '4' }
          ]}
          answer={info.quarter}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
        />
        <PulpoField
          key="year"
          id="year"
          type="date"
          className={styles.month}
          translationID="workorder.create.datea"
          title="Year"
          avp
          dateFormat="YYYY"
          widget={{ type: 'year' }}
          isRequired
          handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
          answer={info.year}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
        />
        <PulpoField
          key="description"
          id="description"
          type="string"
          translationID="workorder.create.datea"
          title="Description"
          widget={{ type: 'textarea' }}
          handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
          answer={info.description}
          className={styles.fullInput}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
        />
        <Attachments
        key="attachments" id="attachments" type="attachments"
        title="Attachments"
        attachments={info?.attachments}
        handleFieldErrorChanged={() => {}}
        handleAnswerChanged={(a, b) => handleAnswerChanged('info', a, b)}
        showFieldErrors={showFormErrors} />
        <PulpoField
          key="contract"
          id="contract"
          type="select"
          translationID="workorder.create.select.agreement "
          title="Select agreement"
          handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
          answer={info?.contract}
          values={gross_contracts?.map(i => ({
            key: `${i?.id}`,
            value: `${i?.contract_name}`
          }))}
          isRequired
          showFieldErrors={showFormErrors}
          className={styles.fullInput}
          handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
        />
        {filterCategories?.map((obj, index) => (
          <div className={fieldstyles.categoriesList}>
            <PulpoField
              key="category"
              id="category"
              type="string"
              title="Category"
              translationID="workorder.create.category"
              className={styles.month}
              answer={obj?.name}
              handleFieldErrorChanged={() => {}}
              handleValueChange={() => {}}
              disabled
            />
            <PulpoField
              key="gross_sales"
              id="gross_sales"
              type="currency-phone"
              title="Gross Sales"
              isRequired
              translationID="workorder.create.catsegory"
              className={styles.month}
              handleValueChange={(a, b) => handleAnswerChanged('categories', a, b, index, info?.contract)}
              answer={obj?.gross_sales}
              thousandSeparator
              placeHolderValue={prefix || '$'}
              prefix={prefix || '$'}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="rate"
              id="rate"
              type="string"
              title="Rate"
              translationID="workorder.create.castegory"
              className={styles.month}
              answer={`${obj.rate}%`}
              disabled
              handleFieldErrorChanged={() => {}}
              handleValueChange={() => {}}
            />
            <PulpoField
              key="percentage_rent"
              id="percentage_rent"
              type="currency-phone"
              title="Percentage Rent"
              translationID="workorder.create.catesgory"
              className={styles.month}
              answer={obj?.percentage_rent?.toFixed(2)}
              thousandSeparator
              placeHolderValue={prefix || '$'}
              prefix={prefix || '$'}
              handleFieldErrorChanged={() => {}}
              disabled
              handleValueChange={() => {}}
            />
          </div>
        ))}
        <div className={styles.itemsFooter}>
          <div className={styles.totalAmount}>
        {filterCategories?.length > 0
        && <p className={styles.totalTax} style={{ 'width': '73%', display: 'flex', justifyContent: 'flex-start' }}>
              <FormattedMessage
                id="invoices.create.fdddee"
                defaultMessage="Total Gross Sales: "
              />
              <NumberFormat
                displayType="text"
                decimalScale={2}
                value={getTotalRent(filterCategories, 'gross_sales')}
                thousandSeparator
                prefix={prefix}
              />
           </p>}
            <p className={styles.totalTax}>
              <FormattedMessage
                id="invoices.creaste.sub_total"
                defaultMessage="Total Rent Due: "
              />
              <NumberFormat
                displayType="text"
                decimalScale={2}
                value={getTotalRent(filterCategories, 'total')}
                thousandSeparator
                prefix={prefix}
              />
            </p>

            <p className={styles.totalTax}>
              <FormattedMessage
                id="invoices.create.stax"
                defaultMessage="Minimum Annual Guarantee: "
              />
              <NumberFormat
                displayType="text"
                decimalScale={2}
                value={min_val}
                thousandSeparator
                prefix={prefix}
              />
            </p>
            <p className={styles.totalTax}>
              <FormattedMessage
                id="invoices.create.fdddee"
                defaultMessage="Rent Balance: "
              />
              <NumberFormat
                displayType="text"
                decimalScale={2}
                value={getTotalRent(filterCategories, 'rent', min_val)}
                thousandSeparator
                prefix={prefix}
              />
            </p>
          </div>
        </div>
      </>
    );
  }
}

FixedFields.propTypes = {
  info: PropTypes.shape({}).isRequired,
  handleAnswerChanged: PropTypes.func.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool,
  userlist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchForUser: PropTypes.func.isRequired
  // categories: PropTypes.shape({}).isRequired
};

FixedFields.defaultProps = {
  showFormErrors: false
};

export default FixedFields;
